var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":function($event){return _vm.toHomeIndex()}}},[_c('img',{attrs:{"src":require("../assets/home/err404.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }